import React from 'react';
import {Link} from 'gatsby';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  useMediaQuery,
  Grid,
  Typography,
  Divider,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
} from '@material-ui/core';
import { SectionHeader, DescriptionCta } from 'components/molecules';
import { CardBase } from 'components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    '& .description-cta__button-group': {
      flexWrap: 'nowrap',
    },
  },
  title: {
    fontWeight: 'bold',
  },
  divider: {
    margin: theme.spacing(3, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(5, 0),
    },
  },
  textWhite: {
    color: 'white',
  },
  cardHighlighted: {
    background: theme.palette.primary.dark,
  },
  checkBox: {
    background: 'transparent',
    borderRadius: 0,
  },
  list: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
}));

const Main = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <DescriptionCta
        title="Teritory Sales Manager"
        subtitle="Chennai· Full time"     
        primaryCta={
          <Button variant="outlined" color="primary" size="large">
            Refer a friend
          </Button>
        }
        secondaryCta={
          <Button variant="contained" color="primary" size="large">
            Apply now
          </Button>
        }
        align={'left'}
        titleProps={{
          variant: 'h3',
          className: classes.title,
          color: 'textPrimary',
        }}
        subtitleProps={{
          color: 'textPrimary',
        }}
      />

      



      <Divider className={classes.divider} />
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} md={8}>
          <SectionHeader
            title="Basic Function and Scope of the Position"
            subtitle="Basic Function and Scope of the Position:

            Ensure achievement of territory sales objectives in line with the Company's mission. Control, organize and direct sales activities for brands like Illumina - NGS & Microarray, Covaris, Fluidigm, Genolution, ASKION, ACEA Biosciences through both strategic and tactical activities. Provide regular reports on status of specific sales, potential market opportunities and market conditions, and competitor activities."
            
            align="left"
            data-aos="fade-up"
            titleProps={{
              className: classes.title,
              color: 'textPrimary',
            }}
            subtitleProps={{
              variant: 'body1',
              color: 'textPrimary',
            }}
          />
     
Experience:  2-6 years
<br/>
Vacancies:  01
<br/>
Salary Range: N.A
<br/>
Status: Open
<br/><br/>

  <h3>Role description</h3>   
  <br/>     
<li> Cover the target audience with effective product promotion</li>
<li>Periodic education of customers on product and application updates</li>
<li>Periodic education of customers on product and application updates</li>
<li>Key account management</li>
<li> Market intelligence with respect to projects, new customers and competitor activities</li>
<li> Identifying key areas of growth in the territory</li>
<li> Relationships with KOL</li>
<li> Timely reporting and CRM updation</li>
<li> Effective forecasting</li>
<li> Coordinating with internal and external customers to ensure customer delight</li>
<br/>
          <List className={classes.list}>
         <h3> Mandatory Skills</h3>
         <br/>
            {data.map((item, index) => (
              <ListItem disableGutters key={index} data-aos="fade-up">
                <ListItemAvatar>
       
                  <Avatar
                    src="https://ik.imagekit.io/j6phbjneuop/iconfinder_1814079_approve_check_ok_yes_icon_512px_uLSoNbZvP.png"
                    className={classes.checkBox}
                  />
                </ListItemAvatar>
                <Typography variant="body1" color="textPrimary">
                  {item}
                </Typography>
              </ListItem>
            ))}
          </List>
         
        </Grid>
        <Grid item xs={12} md={4}>
          <Grid container spacing={isMd ? 4 : 2} direction="column">
            <Grid item xs={12} data-aos="fade-up">
              <CardBase withShadow className={classes.cardHighlighted}>
                <SectionHeader
                  title="Know about company"
                  subtitle="Checkout Our Story or signup for our newsletter"
                  ctaGroup={[<Button href = '/Ourstory'variant="contained">learn more</Button>]}
                  disableGutter
                  align="left"
                  titleProps={{
                    variant: 'h6',
                    className: classes.textWhite,
                  }}
                  subtitleProps={{
                    variant: 'body1',
                    className: classes.textWhite,
                  }}
                />
              </CardBase>
            </Grid>
            <Grid item xs={12} data-aos="fade-up">
              <CardBase withShadow>
                <SectionHeader
                  title="Don't see a job for you?"
                  titleVariant="h6"
                  subtitle="Don't worry! Other job openings may interest you."
                  ctaGroup={[
                      <Link to = '/career-listing-minimal'>
                    <Button variant="contained" color="primary">
                      See other vacances
                    </Button>
                    </Link>
                  ]}
                  disableGutter
                  align="left"
                  subtitleProps={{
                    variant: 'body1',
                  }}
                />
              </CardBase>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

Main.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Main;
